import { makeStyles } from '@material-ui/core';

// Panel max width: 40vw at 640px, 30vw at 1280px, linear in-between, clamped outside.
const infoPanelMaxWidth = 'clamp(256px, calc(20vw + 128px), 384px)';

const styles = makeStyles((_theme) => ({
  cardStyle: {
    maxWidth: infoPanelMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    marginTop: '0vh',
    marginBottom: '1.5vh',
    flex: 1,
    marginRight: '1.5vw',
    height: 'calc(100vh - 92px)',
    overflow: 'auto',
  },
  cardStyleDashboard: {
    maxWidth: '80vw',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '0vh',
    marginBottom: '1.5vh',
    flex: 1,
    marginRight: '1.5vw',
    height: 'calc(100vh - 70px)',
    overflow: 'auto',
    position: 'relative',
    boxSizing: 'border-box',
  },
  cardStyleDashboardCollapsed: {
    minWidth: 0,
    maxWidth: 0,
    width: 0,
    marginRight: 0,
    overflow: 'hidden',
    padding: 0,
    flex: 0,
    left: 'auto',
    right: 'auto',
  },
  heatmapPanelToggle: {
    position: 'fixed',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1003,
    backgroundColor: 'rgba(255,255,255,0.9)',
    boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.9)',
    },
  },
  cardStyleDashboardFullWidth: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '0vh',
    marginBottom: '0',
    flex: 1,
    marginRight: '0',
    paddingRight: '0',
    height: '100vh',
    overflow: 'auto',
    transition: 'all 0.3s ease-in-out',
    position: 'fixed',
    left: '75px',
    right: '0',
    zIndex: 1002,
    boxSizing: 'border-box',
    width: 'calc(100% - 75px)',
    paddingBottom: '50px',
  },
  header: {
    textAlign: 'left',
    fontSize: 14,
    marginTop: 5,
    paddingTop: 0,
    paddingBottom: 0,
    marginLeft: '-10px',
  },
  close: {
    width: 35,
    height: 35,
    alignSelf: 'center',
    marginTop: 10,
    marginRight: 10,
    marginLeft: 'auto',
  },
  addNewButton: {
    alignSelf: 'center',
    padding: '0 5px',
  },
  headerBox: {
    display: 'flex',
    position: 'relative',
    margin: 10,
    justifyContent: 'space-between',
  },
  backIcon: {
    width: 35,
    height: 35,
    alignSelf: 'center',
    marginTop: 10,
    marginLeft: 10,
  },
  icons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export default styles;
